// @ts-nocheck

export const isPseudoCdrRow = (row) => {
  const raw =
    row?.is_pseudo_cdr ?? row?.isPseudoCDR ?? row?.isPseudoCdr ?? row?.pseudo_cdr;

  if (raw === true) return true;
  if (raw === false || raw === null || raw === undefined || raw === '') return false;

  const normalized = String(raw).trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes';
};

export const pseudoCdrLabel = (row) => (isPseudoCdrRow(row) ? 'Yes' : 'No');
